import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

import { PageHeader } from '@/components/common/PageHeader';
import { InboundWebhooksPage } from '@/modules/settings/InboundWebhooksPanel';

/**
 * Settings → Integrations → Health
 *
 * Tenant-admin-friendly home for the inbound-webhook observability
 * surface — the same component that powers Developer → Inbound
 * webhooks, just wrapped in a context that surfaces it to
 * non-developer admins (the user who needs to know whether their
 * shipping integrations are actually working, not the developer who
 * wrote them).
 *
 * The Developer page stays in place — same component, different home
 * — so existing bookmarks and links still work.
 */
export function IntegrationsHealthPage() {
  return (
    <div className="space-y-5">
      <PageHeader
        eyebrow="Settings · Integrations"
        title="Integration health"
        description={
          <span>
            Every status push from your delivery partners (Shiprocket, DHL,
            BlueDart, …) lands here. Filter by what each event actually did
            (Applied / Skipped / Errored) and report anything that looks
            wrong straight to the platform team —
            we&apos;ll get notified with the full event snapshot attached.
            For partner credentials and pickup addresses see{' '}
            <Link
              to="/dispatch/partners"
              className="font-medium text-primary underline-offset-2 hover:underline"
            >
              Dispatch partners
              <ArrowUpRight className="ml-0.5 inline h-3 w-3" />
            </Link>
            .
          </span>
        }
      />
      <InboundWebhooksPage embedded />
    </div>
  );
}
